"use client";

import Link from "next/link";

const Footer = () => {
  return (
    <footer className="dark:bg-gray-dark relative z-10 bg-white pt-16 md:pt-20 lg:pt-24">
      <div className="container">
        <div className="-mx-4 flex flex-wrap">
          <div className="w-full px-4 md:w-1/2 lg:w-4/12 xl:w-5/12">
            <div className="mb-12 max-w-[360px] lg:mb-16">
              <Link
                href="/"
                className="mb-6 inline-block bg-gradient-to-r from-blue-400 via-blue-500 to-blue-700 bg-clip-text text-2xl font-bold text-transparent"
              >
                Devkin Technology
              </Link>
              <p className="text-body-color dark:text-body-color-dark mb-8 text-base leading-relaxed">
                Building scalable, modern web solutions with Next.js and
                Tailwind CSS.
              </p>
              <div className="flex items-center space-x-5">
                {["facebook", "twitter", "youtube", "linkedin"].map(
                  (social, idx) => (
                    <a
                      key={idx}
                      href="/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={social}
                      className="text-body-color dark:text-body-color-dark hover:text-primary transition-colors duration-300"
                    >
                      {/* Placeholder for icons (keep your SVGs here) */}
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 22 22"
                        fill="currentColor"
                      >
                        <circle cx="11" cy="11" r="10" />
                      </svg>
                    </a>
                  ),
                )}
              </div>
            </div>
          </div>

          <FooterLinks
            title="Useful Links"
            links={[
              { label: "Blog", href: "/blog" },
              { label: "About", href: "/about" },
            ]}
          />

          <FooterLinks
            title="Terms"
            links={[
              { label: "TOS", href: "/" },
              { label: "Privacy Policy", href: "/" },
              { label: "Refund Policy", href: "/" },
            ]}
          />

          <FooterLinks
            title="Support & Help"
            links={[
              { label: "Open Support Ticket", href: "/contact" },
              { label: "Terms of Use", href: "/" },
              { label: "About", href: "/about" },
            ]}
          />
        </div>

        <div className="my-8 h-px w-full bg-gradient-to-r from-transparent via-gray-300 to-transparent dark:via-gray-600"></div>

        <p className="text-body-color dark:text-body-color-dark text-center text-sm">
          © {new Date().getFullYear()} Devkin Technology. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

const FooterLinks = ({
  title,
  links,
}: {
  title: string;
  links: { label: string; href: string }[];
}) => (
  <div className="w-full px-4 sm:w-1/2 md:w-1/2 lg:w-2/12 xl:w-2/12">
    <div className="mb-12 lg:mb-16">
      <h3 className="mb-6 text-lg font-semibold text-black dark:text-white">
        {title}
      </h3>
      <ul className="space-y-4">
        {links.map(({ label, href }) => (
          <li key={label}>
            <Link
              href={href}
              className="text-body-color dark:text-body-color-dark hover:text-primary dark:hover:text-primary transition-colors duration-300"
            >
              {label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  </div>
);

export default Footer;
